const API_ENDPOINTS = {
  USER_VALIDATE_TOKEN: "admin/validate-token",
  USER_LOGIN: "admin/login",
  USER_UPDATE_PROFILE: "admin/update-profile",
  USER_UPDATE_PASSWORD: "admin/update-password",

  USER_LIST: 'user/list',
  USER_DETAIL: 'user/detail/',
  USER_SAVE: 'user/save',
  USER_TOGGLE_STATUS: 'user/toggle/status',
  USER_UPDATE_VERFICATIONS: 'user/update-selfie-verification-status',

  
  USER_SUBSCRIPTION_LIST: 'subscription/list',

  // report routes
  REPORT_LIST: 'report/list',
  REPORT_TOGGLE_STATUS: 'report/toggle/status',

  //RIDER ROUTES
  LIST_RIDER: "/rider/list",
  DELETE_RIDER: "/rider/delete",
  DETAILS_RIDER: "/rider/",
  SAVE_RIDER: "/rider/save",

  RIDER_TOGGLE_KYC_STATUS: "/rider/toggle/kyc-status",
  RIDER_TOGGLE_STATUS: "/rider/toggle/status",
  RIDER_TOGGLE_VERIFICATION: "/rider/toggle/verification",

  RIDER_BANK_ACCOUNT_DETAIL: "/rider/bank-account/",
  RIDER_BANK_ACCOUNT_SAVE: "/rider/bank-account/save",

  RIDER_ADDRESS_SAVE: "/rider/address/save",
  RIDER_ADDRESS_DETAILS: "rider/address/",

  RIDER_DOCUMENTS_LIST: "/rider/documents/list",
  RIDER_DOCUMENTS_SAVE: "/rider/documents/save",
  RIDER_DOCUMENTS_DELETE: "/rider/documents/delete",

  //FILE ROUTES
  FILE_UPLOAD: "file/save",
  FILE_REMOVE: "file/remove",

  //Various Routes
  VARIOUS_APPLICATION_DETAIL: "various/application/",
  VARIOUS_APPLICATION_LIST: "various/application/list",
  VARIOUS_APPLICATION_SAVE: "various/application/save",

  VARIOUS_SETTING_DETAIL: "various/setting/",
  VARIOUS_SETTING_LIST: "various/setting/list",
  VARIOUS_SETTING_SAVE: "various/setting/save",

  //Query Routes
  QUERY_LIST: "/query/list",
  QUERY_DETAILS: "/query/detail/",
  QUERY_DELETE: "/query/delete",
  QUERY_REPLY: "/query/save",

  //Query Routes
  NOTIFICATION_LIST: "/notification/list",
  NOTIFICATION_DETAILS: "/notification/details/",
  NOTIFICATION_DELETE: "/notification/delete",
  NOTIFICATION_SAVE: "/notification/save",

  //Master Routes
  MASTER_LANGUAGE_LIST: "/master/language/list",
  
  MASTER_PINCODE_LIST: "/pincode/list",
  MASTER_PINCODE_DELETE: "/pincode/delete",
  MASTER_PINCODE_SAVE: "/pincode/save",

  MASTER_LANGUAGE_DETAIL: "/master/language/",
  MASTER_LANGUAGE_DELETE: "/master/language/delete",
  MASTER_LANGUAGE_SAVE: "/master/language/save",
  MASTER_LANGUAGE_TOGGLE_STATUS: "/master/language/toggle/status",

  //Agency Routes
  LIST_AGENCY: "/agency/list",
  DELETE_AGENCY: "/agency/delete",
  DETAILS_AGENCY: "/agency/details/",
  SAVE_AGENCY: "/agency/save",

  AGENCY_TOGGLE_KYC_STATUS: "/agency/toggle/kyc-status",
  AGENCY_TOGGLE_STATUS: "/agency/toggle/status",
  AGENCY_TOGGLE_VERIFICATION: "/agency/toggle/verification",
  AGENCY_TOGGLE_LOGIN_ACCESS: "/agency/toggle/login-access",
  
  AGENCY_BANK_ACCOUNT_DETAIL: "agency/bank-account/",
  AGENCY_BANK_ACCOUNT_SAVE: "/agency/bank-account/save",

  AGENCY_DOCUMENTS_LIST: "/agency/documents/list",
  AGENCY_DOCUMENTS_SAVE: "/agency/documents/save",
  AGENCY_DOCUMENTS_DELETE: "/agency/documents/delete",

  AGENCY_VISIT_BULK_UPLOAD: "/agency/visit/bulk-upload",
  AGENCY_VISIT_LIST: "/agency/visit/list",
  AGENCY_VISIT_DETAILS: "/agency/visit/details/",
  AGENCY_VISIT_LOCATION_HISTORY: "/agency/visit/location-history/",

  AGENCY_ADDRESS_SAVE: "/agency/address/save",
  AGENCY_ADDRESS_DETAILS: "/agency/address/",
  AGENCY_VISIT_STATUS_LIST: "/agency/visit/status-list",
  AGENCY_VISIT_CREATE_PAYMENT: "/agency/visit/create-transaction",
  AGENCY_ASSIGN_RIDER: "/agency/visit/assign-rider",

  TRANSACTION_LIST: "/transaction/list",
  TRANSACTION_APPROVED_MANY: "/transaction/make-approved-many",
  TRANSACTION_CANCELLED_MANY: "/transaction/make-cancel-many",

  DASHBOARD_LIST: "/dashboard/data",

  // AI Performance Routes
  AI_PERFORMANCE_OVERVIEW: "/ai-performance/overview",

  // Install Attribution Stats Routes
  INSTALL_ATTRIBUTION_BREAKDOWN: "/install-attribution-stats/breakdown",

  GROWTH_ANALYTICS_OVERVIEW: "/growth-analytics/overview",

  // Blog Routes
  BLOG_LIST: 'blog/list',
  BLOG_SAVE: 'blog/save',
  BLOG_DELETE: 'blog/delete/',

  // Notification Campaign Routes
  NOTIFICATION_CAMPAIGN_LIST: 'notification-campaign',
  NOTIFICATION_CAMPAIGN_CREATE: 'notification-campaign',
  NOTIFICATION_CAMPAIGN_PREVIEW: (id) => `notification-campaign/${id}/preview`,
  NOTIFICATION_CAMPAIGN_SEND: (id) => `notification-campaign/${id}/send`,

  // Moderation / Ghost Profiles Routes
  MODERATION_GHOST_PROFILES_LIST: 'moderation/ghost-profiles',
  MODERATION_GHOST_PROFILES_EXPORT: 'moderation/ghost-profiles/export',
  MODERATION_HIDE_PROFILES: 'moderation/hide',
  MODERATION_UNHIDE_PROFILES: 'moderation/unhide',
};

export default API_ENDPOINTS;
